import React from "react";
import PropTypes from "prop-types";

export default function Variable(props) {
  const { label, active, ...restProps } = props;
  return (
    <div className={`variable ${active ? "active" : ""}`} {...restProps}>
      <span className="variable-title">{label} </span>
    </div>
  );
}

Variable.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool
};

Variable.defaultProps = {
  active: false
};
